import { render, staticRenderFns } from "./njddDiaImg.vue?vue&type=template&id=253cdc00&scoped=true&"
import script from "./njddDiaImg.vue?vue&type=script&lang=js&"
export * from "./njddDiaImg.vue?vue&type=script&lang=js&"
import style0 from "./njddDiaImg.vue?vue&type=style&index=0&id=253cdc00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253cdc00",
  null
  
)

export default component.exports